import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const financePerformanceReportWidget: DashboardWidgetConfiguration = {
  widgetId: "finance.performance-report",
  name: "Financial performance",
  description: "Financial performance using the reusable report-widget visualization.",
  apps: [
    "home",
    "finance",
  ],
  template: "report",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "finance.journal-items",
      ...period(30),
      select: [
        {
          type: "field",
          field: "account_type",
          as: "account_type",
        },
        {
          type: "aggregate",
          function: "sum",
          field: "balance",
          as: "balance",
        },
      ],
      group_by: [
        {
          field: "account_type",
        },
      ],
      order_by: [
        {
          ref: "balance",
          direction: "desc",
        },
      ],
      limit: 8,
    },
  },
  inputs: {
    title: "Financial performance",
    subtitle: "Live RQL report",
    output: "category_series",
    visualization: "bar",
    icon: "average",
    showTimeControls: true,
  },
  dummyData: {
    value: "$14,400",
    series: [
      18,
      30,
      24,
      42,
      35,
    ],
  },
  limits: {
    minWidth: 6,
    maxWidth: 12,
    minHeight: 3,
    maxHeight: 8,
    defaultWidth: 6,
    defaultHeight: 4,
  },
};
